// ** React Imports
import { Link, useNavigate } from 'react-router-dom'

// ** Custom Components
import Avatar from '@components/avatar'

// ** Third Party Components

// ** Reactstrap Imports
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from 'reactstrap'

// ** Default Avatar Image
import CustomPermissions from '../../../../common/CustomPermissions'
import NavRoutes from '../../../../common/NavRoutes'
import useAuth from '../../../../hooks/useAuth'
import useUser from '../../../../hooks/useUser'
import { havePermission } from '../../../../utility/Utils'

const UserDropdown = () => {
  const { user } = useUser()
  const { token } = useAuth()
  const navigate = useNavigate()

  return token && user ? (
    <UncontrolledDropdown tag='li' className='dropdown-user nav-item'>
      <DropdownToggle
        href='/'
        tag='a'
        className='nav-link dropdown-user-link'
        onClick={(e) => e.preventDefault()}
      >
        <div className='user-nav d-sm-flex d-none'>
          <span className='user-name fw-bold'>{user?.name}</span>
          <span className='user-status'>{user?.roles[0].name}</span>
        </div>
        <Avatar color='secondary' content={`${user?.name}`} initials />
      </DropdownToggle>
      <DropdownMenu end>
        {havePermission(user?.permissions, CustomPermissions.rolesView) ? (
          <DropdownItem
            tag={Link}
            to='#'
            onClick={(e) => {
              e.preventDefault()
              navigate(NavRoutes.roles)
            }}
          >
            <span className='align-middle'>Roles</span>
          </DropdownItem>
        ) : null}

        {havePermission(
          user?.permissions,
          CustomPermissions.permissionsView
        ) ? (
          <DropdownItem
            tag={Link}
            to='#'
            onClick={(e) => {
              e.preventDefault()
              navigate(NavRoutes.permissions)
            }}
          >
            <span className='align-middle'>Permissions</span>
          </DropdownItem>
        ) : null}
        {user?.roles[0].id === 1 ? (
          <DropdownItem tag={Link} to={NavRoutes.adminControl}>
            <span className='align-middle'>Admin Control</span>
          </DropdownItem>
        ) : null}
        <DropdownItem tag={Link} to='/login'>
          <span className='align-middle'>Logout</span>
        </DropdownItem>
        {/* ) : null} */}

        {/* <DropdownItem divider />
        <DropdownItem
          tag={Link}
          to='/pages/'
          onClick={(e) => e.preventDefault()}
        >
          <Settings size={14} className='me-75' />
          <span className='align-middle'>Settings</span>
        </DropdownItem>
        <DropdownItem tag={Link} to='/' onClick={(e) => e.preventDefault()}>
          <CreditCard size={14} className='me-75' />
          <span className='align-middle'>Pricing</span>
        </DropdownItem>
        <DropdownItem tag={Link} to='/' onClick={(e) => e.preventDefault()}>
          <HelpCircle size={14} className='me-75' />
          <span className='align-middle'>FAQ</span>
        </DropdownItem>
        <DropdownItem tag={Link} to='/login'>
          <Power size={14} className='me-75' />
          <span className='align-middle'>Logout</span>
        </DropdownItem> */}
      </DropdownMenu>
    </UncontrolledDropdown>
  ) : null
}

export default UserDropdown
